<div *ngIf="isVisible" class="ad-loader-bg"></div>
